// extracted by mini-css-extract-plugin
module.exports = {"transactionTableTitle":"AdminCancellationComponent_transactionTableTitle__25mmS","transactionTable":"AdminCancellationComponent_transactionTable__18mU5"};